import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { UsersAdminList } from 'src/app/interfaces/users-admin-list';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { TranslatorService } from 'src/app/services/translator.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-user-account-admin',
    templateUrl: './user-account-admin.component.html',
    styleUrls: ['./user-account-admin.component.scss'],
    standalone: false
})
export class UserAccountAdminComponent {
     isLoading: boolean = false;
     filterString: string = "";
     pageSize: string = "10";
     startIndex: number = 0;
     userProfile: UserProfile;
     userList: UsersAdminList[] = [];
     viewList: UsersAdminList[] = [];
     sortOnInfo: string = "name_down"
     _currentPage: number = 1;
     _filteredLength: number = 0;
     disableUsername: string = '';
     disableUserEmail: string = '';
     restrictedUsername:string = '';
     showToast:boolean = false;
     toastIsError:boolean = false;

     @ViewChild('disableModal') disableRef!: TemplateRef<any>;
     @ViewChild('showRestrictedUserModal') restrictedRef!:TemplateRef<any>;

     constructor(public generalService: GeneralService, public translator: TranslatorService,
          private authenticationService: AuthenticationService, private router: Router,
          private userManagementService: UserManagementService, private modalService: NgbModal) {
          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
          userManagementService.getUsersForCustomer().subscribe((result: any[]) => this.loadCustomerUsers(result));;
          this.scrollToTop();
     }

     loadCustomerUsers(customerUsers: UsersAdminList[]) {
          this.userList = customerUsers;
          this.filterList();
          this.isLoading = false;
     }

     private getTestDate(tDate: Date | null): number {
          if (tDate !== null) {
               return new Date(tDate).valueOf();
          } else {
               return new Date("01/14/1970").valueOf();
          }
     }

     filterList() {
          //1st sort
          if (this.sortOnInfo !== "") {
               if (this.sortOnInfo === 'name_down') {
                    this.userList.sort((a, b) => a.username.localeCompare(b.username));
               } else if (this.sortOnInfo === 'name_up') {
                    this.userList.sort((a, b) => b.username.localeCompare(a.username));
               } else if (this.sortOnInfo === 'last_down') {
                    this.userList.sort((a, b) => this.getTestDate(a.lastLoginDate) - this.getTestDate(b.lastLoginDate));
               } else {
                    this.userList.sort((a, b) => this.getTestDate(b.lastLoginDate) - this.getTestDate(a.lastLoginDate));

               }
          }
          //2nd seach Filter;
          if (this.filterString.trim() !== "") {
               this.viewList = this.userList.filter(u =>
                    u.username.toLocaleLowerCase().includes(this.filterString.toLocaleLowerCase()) ||
                    u.email.toLocaleLowerCase().includes(this.filterString.toLocaleLowerCase())
               ) || [];
          } else {
               this.viewList = this.userList;
          }

          this.viewList = this.viewList.filter(row => !row.email.includes('_released_'));

          this._filteredLength = this.viewList.length;

          //page and row count Filter
          this.viewList = this.viewList.filter((u, index) =>
               index >= this.startIndex && index < this.startIndex + (parseInt(this.pageSize))) || [];
     }



     setCurrentPage(action: 'f' | 'p' | 'n' | 'l') {
          switch (action) {
               case 'f':
                    if (!this.disableFirstPage) {
                         this._currentPage = 1;
                         this.startIndex = 0;
                    }
                    break;
               case 'p':
                    if (!this.disablePreviousPage) {
                         this._currentPage--;
                         this.startIndex -= parseInt(this.pageSize);
                         if(this.startIndex < 0){
                              this.startIndex = 0;
                         }
                    }
                    break;
               case 'n':
                    if (!this.disableNextPage) {
                         this._currentPage++;
                         this.startIndex += parseInt(this.pageSize);
                    }
                    break;
               default:
                    if (!this.disableLastPage) {
                         this._currentPage = this.totalPages;
                         this.startIndex =  ((this.totalPages - 1) * parseInt(this.pageSize));
                    }
                    break;
          }
          this.filterList();
     }

     onPageSizeChanged() {
          this._currentPage = 1;
          this.startIndex = 0;
          this.filterList();
     }

     edit(username: string) {
          this.router.navigate(['/editAccountAdmin'], { queryParams: { id: username } });
     }

     isPowerUser(email:string){
          if(this.userProfile.customer.powerUserEmail!.toLowerCase() === email.toLowerCase()){
               return true;
          }
          return false;
     }

     isBillingUser(email:string){
          if(this.userProfile.customer!.billingInfo!.contactEmailId!.toLowerCase() === email.toLowerCase()){
               return true;
          }
          return false;
     }

     isAuditUser(email:string, username: string){
          //there is a mismatch on the object we get back from next and the object we have in tug
          //I dont want to mess with the user Interface in tug because we use it all over the place
          //I dont want to mess with the AuditContact in next because I dont know what it might brake in CRS land
          //so I just cast auditContact as any so I can make userName into username
          const AuditContact: any = (this.userProfile.customer!.auditContact! as any);
          
          //we dont get back a email on the audit contact. we get back a username that may or may not be a email.
          //so I need to get auditContact.username vs both the email and username on the user.
          if(AuditContact && this.userProfile.customer!.auditContact && AuditContact.username && 
               (AuditContact.username.toLowerCase() === email.toLowerCase() 
               || AuditContact.username!.toLowerCase() === username.toLowerCase())){
               return true;
          }
          return false;
     }

     
     disable(username: string, email:string, user: UsersAdminList) {
          const isYou = this.userProfile.userData.userName.toLowerCase() === username.toLowerCase();
          const isPowerUser = this.userProfile.customer.powerUserEmail!.toLowerCase() === email.toLowerCase();
          const isBillingUser = this.userProfile.customer!.billingInfo!.contactEmailId === email.toLowerCase();
          const AuditContact: any = (this.userProfile.customer!.auditContact! as any);
          const isAuditUser = (this.userProfile.customer!.auditContact !== null && (
               AuditContact.username!.toLowerCase() === email.toLowerCase() || 
               AuditContact.username!.toLowerCase() === username.toLowerCase()
          ));
          this.disableUsername = username;
          this.disableUserEmail= email;
          if(isYou || isPowerUser || isBillingUser || isAuditUser){
               this.modalService.open(this.restrictedRef, { ariaLabelledBy: 'showRestrictedUserModalTitle' });
          }else{
               this.modalService.open(this.disableRef, { ariaLabelledBy: 'disableModalTitle' });
          }
          
          
          
     }
     cancelDisable() {
          this.disableUsername = '';
          this.disableUserEmail = '';
          this.modalService.dismissAll(this.disableRef);
     }
     

     closeRestrictedUserModal() {
          this.restrictedUsername = '';
          this.modalService.dismissAll(this.restrictedRef);
     }

     disableUser() {
          this.modalService.dismissAll(this.disableRef);
          this.isLoading = true;

          const disablePromise = this.userManagementService.disableUser(this.disableUsername);
          disablePromise.subscribe((response: any) => {
               if (response) {;
                    this.toastIsError = false;
                    this.showToast = true;
                    this.userManagementService.getUsersForCustomer().subscribe((result: any[]) => this.loadCustomerUsers(result));;
                    
               } else {

                    this.toastIsError = true;
                    this.showToast = true;
                    this.isLoading = false;
               }

               this.disableUsername = '';
               this.disableUserEmail = '';
          })
     }




     get disableFirstPage() {
          return this._currentPage === 1;
     }

     get disablePreviousPage() {
          return this._currentPage === 1;
     }

     get disableNextPage() {
          return this._currentPage === this.totalPages;
     }

     get disableLastPage() {
          return this._currentPage === this.totalPages;
     }

     get currentPage() {
          return this._currentPage;
     }

     get totalPages() {
          return Math.ceil(this._filteredLength / parseInt(this.pageSize));
     }

     get recored_X_To() {
          return this.startIndex + 1;
     }

     get recored_X_To_Y() {
          let to_ = this.startIndex + parseInt(this.pageSize);
          if (to_ > this._filteredLength) {
               to_ = this._filteredLength;
          }
          return to_;
     }



  





     doTranslation(translationTag: string): string {
          let translatedText: string = this.generalService.getTranslation(translationTag, 'customer')
          if (translatedText === undefined) {
               translatedText = this.generalService.getTranslation(translationTag, 'customer');
          }
          return translatedText;
     }

     updateUrl(url: string) {
          url = url.replace(`##docBaseUrl##`, environment.APP_PSP_DOC_BASE_URL);
          return url;
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }



     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
